<template>
	<div class="layout-details">
		<div
			class="layout-details__image"
			v-if="$slots.image"
		>
			<slot name="image"/>
		</div>

		<header
			class="layout-details__header"
			v-if="$slots.title || $slots.controls"
		>
			<div
				class="layout-details__title"
				v-if="$slots.title"
			>
				<slot name="title"/>
			</div>
			<div
				class="layout-details__controls"
				v-if="$slots.controls"
			>
				<slot name="controls"/>
			</div>
		</header>

		<div class="details">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.layout-details {
	display: inline-flex;
	flex-direction: column;
	justify-content: flex-start;

	.details {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
	}

	.details > * {
		margin: 1em 0;

		> * {
			display: inline-block;
			min-width: 180px;
		}
	}

	&__header {
		box-shadow: 0 1px 0 $default-light;
		padding: 1em 0;
		margin-bottom: 1em;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}

	&__controls {
		display: inline-block;
	}

	&__controls > * {
		display: inline-block;
		margin-left: 1em;
	}

	&__title {
		display: inline-block;
		font-weight: bold;
		text-transform: capitalize;
	}

	&__image {
		margin-bottom: 2em;
	}

	&__image > * {
		width: 100px;
		height: 100px;
		min-width: unset;
		background-size: cover;
		border-radius: 50%;
	}
}
</style>
